<template>
    <div class="blurb_text_popup">
        <div class="modal-backdrop"></div>
        <div class="modal modal-open unsupported-browser">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body text-center">
                        <p> Please enable cookies for optimal usage of this website.</p>
                        <button type="button" class="btn btn-primary" @click="blurbTextPopupClosed">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/*eslint-disable */
import { bus } from '@/main';
export default {
    name: 'blocked-cookies-in-safari-popup',
    components: {},
    props: [],
    data() {
        return {
        }
    },
    computed: {

    },
    mounted() {
    },
    methods: {
        blurbTextPopupClosed() {
            bus.$emit('blockedCookiesPopupStateBus', false);
            document.body.classList.remove('body_right_scroll_remove');
        }
    }
}
</script>
<style lang="scss" scoped>
.blurb_text_popup {
    a:hover {
        text-decoration: none;
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1040;
        background-color: #000;
        opacity: .92;
    }

    .unsupported-browser {
        &.modal {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1050;
            overflow: hidden;
            outline: 0;

            &.modal-open {
                overflow-x: hidden;
                overflow-y: auto;
                display: block;
            }

            .modal-dialog {
                position: relative;
                width: auto;
                margin: .5rem;
                pointer-events: none;

                @media (min-width: 540px) {
                    max-width: 540px;
                    margin: 1.75rem auto;
                }

                &.modal-dialog-centered {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    min-height: calc(100% - (.5rem * 2));

                    @media (min-width: 576px) {
                        min-height: calc(100% - (1.75rem * 2));
                    }
                }

                .modal-content {
                    position: relative;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    width: 100%;
                    pointer-events: auto;
                    background-color: #000000;
                    background-clip: padding-box;
                    border: 1px solid rgba(255, 255, 255, .2);
                    border-radius: .3rem;
                    outline: 0;
                    box-shadow: -1px -1px 18px rgba(251, 247, 165, 0.3);

                    .modal-body {
                        padding: 25px;

                        @media (max-width: 575px) {
                            padding: 15px;
                        }

                        h3 {
                            color: #ffc800;
                            font-weight: 600;
                            letter-spacing: 1px;
                            line-height: 1.6;
                            font-size: 20px;
                            text-transform: uppercase;

                            @media (max-width: 575px) {
                                font-size: 14px;
                            }
                        }

                        p {
                            letter-spacing: 1px;
                            color: #ffffff;
                            font-weight: normal;
                            font-size: 18px;
                            font-family: 'MyriadProRegular', 'Lato', sans-serif;
                            line-height: 1.3;

                            @media (max-width: 575px) {
                                font-size: 13px;
                            }
                        }

                        a {
                            color: #2baeff;

                            &:hover {
                                text-decoration: none;
                            }
                        }

                        .btn {
                            background: #ffc800 !important;
                            border: none !important;
                            color: #000 !important;
                            -webkit-box-shadow: none !important;
                            box-shadow: none !important;
                            font-size: 18px;
                            font-weight: 600;
                            font-family: 'MyriadProRegular', 'Lato', sans-serif;
                            letter-spacing: 1px;

                            &:hover {
                                background: #87cefa !important;
                                color: #22292f !important;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>